const getRestrictedReps = (licensingInfos) => Object.entries(licensingInfos).reduce((acc, [polygonId, licensingInfo]) => {
    acc[polygonId] ??= [];
    return licensingInfo.reduce((acc, licensingRepInfo) => {
        if (!licensingRepInfo.has_access_to_work) {
            acc[polygonId].push(licensingRepInfo.rep_id);
        }
        return acc;
    }, acc);
}, {});
export default getRestrictedReps;
